export default __webpack_public_path__ + "static/media/Back.e8016dac.svg";